import apiClient from './axios.config';
import { API_ROUTES } from '@/constants/api.constants';
import type {
  ApInvoice,
  ArInvoice,
  ChartOfAccount,
  GlStatementsResponse,
  JournalEntry,
} from '@/types/api';

export const financeApi = {
  listAp: async (): Promise<{ data: ApInvoice[] }> => {
    const { data } = await apiClient.get<{ data: ApInvoice[] }>(API_ROUTES.FINANCE_AP);
    return data;
  },
  dualControlRelease: async (
    id: string,
    body: { preparer: string; approver: string; releaser: string; reason: string }
  ) => {
    const { data } = await apiClient.post(
      `${API_ROUTES.FINANCE_AP}/${id}/dual-control-release`,
      body
    );
    return data;
  },
  listAr: async (): Promise<{ data: ArInvoice[] }> => {
    const { data } = await apiClient.get<{ data: ArInvoice[] }>(API_ROUTES.FINANCE_AR);
    return data;
  },
  voidAr: async (id: string, reason: string): Promise<{ data: ArInvoice }> => {
    const { data } = await apiClient.post<{ data: ArInvoice }>(
      `${API_ROUTES.FINANCE_AR}/${id}/void`,
      { reason }
    );
    return data;
  },
  glStatements: async (): Promise<{ data: GlStatementsResponse }> => {
    const { data } = await apiClient.get<{ data: GlStatementsResponse }>(API_ROUTES.FINANCE_GL);
    return data;
  },
  chartOfAccounts: async (): Promise<{ data: ChartOfAccount[] }> => {
    const { data } = await apiClient.get<{ data: ChartOfAccount[] }>('/finance/chart-of-accounts');
    return data;
  },
  journals: async (): Promise<{ data: JournalEntry[] }> => {
    const { data } = await apiClient.get<{ data: JournalEntry[] }>('/finance/journals');
    return data;
  },
};

export default financeApi;
